import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {IClientModel} from "../../../models/clients/clients.model";
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {StaticDataService} from "../../../services/StaticData.service";
import * as _ from "lodash";
import {AreaCodesService} from "../../../models/area-codes/area-codes.service";
import {AreaCodesModel} from "../../../models/area-codes/area-codes.model";
import {ApplicationUser} from "../../../services/ApplicationUser";
import {RoleTypes} from "../../../models/roles";

import {phoneFormatter} from "../../../helpers/phone-format";

@Component({
    selector: 'business-information',
    templateUrl: 'business-information.template.html',
    exportAs: 'business-information'
})
export class BusinessInformationComponent {

    phoneFormatter = phoneFormatter;

    @Input('client')
    @Output('client')
    public client: IClientModel = {
        mailing_location: new ClientLocationsModel(),
        business_location: new ClientLocationsModel(),
        prior_advances: 0
    };

    @Input('editMode')
    public editMode = false;

    public industries = [];

    public priorAdvancesList = [];
    public areaCodesList = <AreaCodesModel[]> [];

    private _role: RoleTypes;

    constructor(
        public areaCodesService: AreaCodesService,
        public appUser: ApplicationUser
    ) {
        this.industries = StaticDataService.getInstance().getData();
        this._role = appUser.user.role;
    }

    ngOnInit() {

        this.priorAdvancesList = [

            {
                value: 0,
                name: '0'
            },

            {
                value: 1,
                name: '1'
            },

            {
                value: 2,
                name: '2'
            },
            {
                value: 3,
                name: '3+'
            },
        ];

        this.areaCodesService.getList()
            .subscribe((res) => {
                this.areaCodesList = res.data;
            })
    }

    getPriorAdvancesName() {
        let item = _.find(this.priorAdvancesList, {value: this.client.prior_advances});

        return item ? item.name : '';
    }

    canEditPercentOfVolume(): boolean {
        return [RoleTypes.UNDERWRITER, RoleTypes.OWNER].indexOf(this._role) > -1;
    }

    getUrl(url: any): any 
    {
        if (! url) return null;
        let url_prep: any;
        try {
            url_prep = new URL(url);
        } catch (e) {
            return false;
        }

        return url_prep.href;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/business-information/business-information.component.ts